<div class="start" *ngIf="!loading">
    <div class="centered-container welcome">
        <p class="welcome" *ngIf="user" (click)="vm.service.skipToProjectList();">Welcome,
            <strong>{{ user.firstName }}!</strong></p>
    </div>
    <div class="title centered-container">
        <h2>Upload Data File</h2>
        <button class="inline icon btn btn-transparent" title="Help" (click)="toggleHelp()">
            <span class="icon icon-ui-question"></span>
        </button>
    </div>
    <div class="centered-container" *ngIf="showHelp">
        <div class="help highlight">
            <button class="close" (click)="showHelp = false;">
                <span class="icon icon-ui-close"></span>
            </button>
            <h4>Upload Spreadsheet Data File</h4>
            <p>Drag and drop an Excel or CSV file from your PC into the grey box below.</p>
            <h4>File Formats</h4>
            <p>The program will accept .csv, .xls and .xlsx files.</p>
            <h4>Troubleshooting</h4>
            <p>If you get an error, open the file in Excel and save it as CSV file instead. Sometimes certain Excel
                files cause the Excel parser component to fail. (We don't know why.) </p>
        </div>
    </div>
    <div class="centered-container dropbox-outer" (drop)="drop($event)" (dragover)="dragEnter($event)"
        (dragover)="dragOver($event)" (dragleave)="dragLeave($event)" [class.drag-over]="isfileDraggedOver">
        <div class="petl-app-dropbox">Drag CSV or Excel file here...</div>
    </div>
    <div class="centered-container bottom-padding">
        <button class="btn btn-primary" (click)="browseToUploadFile()">
            <span class="icon icon-ui-upload"></span>
            <span class="button-title">Upload File from Computer...</span>
        </button>
        <input type="file" id="fileSelectedButton" #fileSelectedButton (change)="fileSelected()" />
    </div>
    <div class="centered-container starting-row-number bottom-padding">
        <label>Starting Row Number with Data:</label>
        <input type="number" class="form-control" id="startRow" name="startRow" min="0" max="10"
            [(ngModel)]="startNumber">
        <div class="auto-detect"><span>Leave Blank to Auto-detect</span></div>
    </div>
</div>
